@if (label()) {
	<label class="input-label" [for]="inputId">{{ label() }}</label>
}
<label class="base-input-container">

	<!-- Left side content -->
	@if (iconLeft(); as iconLeft) {
		<div
			class="left-content"
			[class.clickable]="leftContentClickable()"
			>
			<base-icon class="icon" [icon]="iconLeft" (click)="handleIconClick($event)" />
		</div>
	} @else {
		<div
			class="left-content"
			[class.clickable]="leftContentClickable()"
			>
			<ng-content select="[left-content]"></ng-content>
		</div>
	}

	<input
		#inputEl
		[type]="type()"
		[id]="inputId"
		[value]="value"
		[placeholder]="placeholder()"
		[disabled]="disabled()"
		[readonly]="readonly()"
		[autocomplete]="autocomplete()"
		(input)="handleInput($event)"
		(blur)="handleBlur(false)"
		(focus)="handleFocus(true)"
		(onkeyup)="handleKeyUp($event)"
		/>

		<!-- Right side content -->
		@if (iconRight(); as iconRight) {
			<div
				class="right-content"
				[class.clickable]="rightContentClickable()"
				>
				<base-icon class="icon" [icon]="iconRight" (click)="handleIconClick($event)" />
			</div>
		} @else {
			<div
				class="right-content"
				[class.clickable]="rightContentClickable()"
				>
				<ng-content select="[right-content]"></ng-content>
			</div>
		}
	</label>
